import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable, inject } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';

import { DownloadChartsPdfSnackbarComponent } from './download-charts-pdf-snackbar.component';
import type {
  CreateSnackbarArgs,
  SnackbarApi,
} from './download-charts-pdf-snackbar.types';

@Injectable({ providedIn: 'root' })
export class DownloadChartsPdfSnackbarService {
  private readonly overlay = inject(Overlay);

  createSnackbar(args: CreateSnackbarArgs = {}): SnackbarApi {
    const overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay
        .position()
        .global()
        .bottom('1rem')
        .left('1rem'),
      scrollStrategy: this.overlay.scrollStrategies.noop(),
    });

    const portal = new ComponentPortal(DownloadChartsPdfSnackbarComponent);
    const componentRef = overlayRef.attach(portal);

    if (args.message) {
      componentRef.instance.message = args.message;
    }

    return {
      dispose: () => overlayRef.dispose(),
      get message() {
        return componentRef.instance.message;
      },
      set message(value: string) {
        componentRef.instance.message = value;
      },
      get details() {
        return componentRef.instance.details;
      },
      set details(value: string) {
        componentRef.instance.details = value;
      },
    };
  }
}
